const contactPk = {
	breadcrumbs: { home: 'ہوم', contact: 'رابطہ' },
	hero: {
		title: 'ہم سے رابطہ کریں',
		subtitle: 'آپ کے سوالات، آراء یا مدد کے لیے ہم موجود ہیں'
	},
	quick: {
		title: 'جلدی مدد حاصل کریں',
		actions: {
			liveChat: { title: 'لائیو چیٹ', desc: 'فوری مدد حاصل کریں', cta: 'چیٹ شروع کریں' },
			helpCenter: { title: 'ہیلپ سینٹر', desc: 'عام سوالات کے جوابات', cta: 'مدد دیکھیں' },
			business: { title: 'کاروباری پوچھ گچھ', desc: 'شراکت داری اور تعاون', cta: 'ہم سے رابطہ کریں' }
		}
	},
	info: {
		title: 'رابطہ کی معلومات',
		service: { title: 'کسٹمر سروس', desc: 'صبح 9 بجے سے رات 9 بجے تک' },
		email: { title: 'ای میل', desc: 'ہم 24 گھنٹے کے اندر جواب دیتے ہیں' },
		address: {
			title: 'پتہ',
			desc: 'ہفتہ تا جمعرات، صبح 9 - شام 6',
			primary: 'گھر #12، کالج روڈ،',
			secondary: 'دُخا فقیر موڑ، گوروداسپور، ناٹور - 6440'
		}
	},
	form: {
		title: 'پیغام بھیجیں',
		desc: 'اپنی تفصیلات کے ساتھ فارم بھریں۔ ہم 24 گھنٹوں میں رابطہ کریں گے۔',
		name: 'نام',
		email: 'ای میل',
		phone: 'فون',
		subject: 'موضوع',
		message: 'پیغام',
		messagePh: 'اپنا سوال یا تبصرہ تفصیل سے لکھیں...',
		submit: 'بھیجیں',
		success: 'آپ کا پیغام کامیابی سے بھیج دیا گیا ہے۔ ہم جلد رابطہ کریں گے۔'
	},
	hours: {
		title: 'دفتر کے اوقات',
		weekdays: 'ہفتہ - جمعرات',
		friday: 'جمعہ',
		note: 'جمعہ کو عوامی چھٹی کی وجہ سے دفتری خدمات محدود ہوتی ہیں'
	},
	social: { title: 'سوشل میڈیا' },
	faq: {
		title: 'اکثر پوچھے جانے والے سوالات',
		subtitle: 'ممکن ہے آپ کا جواب ہمارے ہیلپ سیکشن میں موجود ہو',
		cta: 'ہیلپ سینٹر پر جائیں'
	}
};

export default contactPk;


